/**
 * Mobile menu drawer.
 *
 * The drawer's own open/close is Dawn's: assets/global.js toggles
 * `.menu-opening` on the <details> when the header summary is clicked, and
 * `.submenu-open` on the parent list when a submenu opens. This file only adds
 * the state CSS needs to know about and that the theme never exposed:
 *
 *   - `.is-menu-open` on the drawer, because the close button lives inside the
 *     drawer and has to fade in with it (CSS cannot see an ancestor's <details>)
 *   - `.icon-open` on the header wrapper, so the hamburger can morph into a
 *     cross
 *   - `aria-expanded` on the header summary, which global.js only sets on the
 *     submenu summaries
 *
 * It is additive and guards every lookup, so a theme without the drawer still
 * loads it harmlessly.
 */
(function () {
  function initMenuDrawerState() {
    var drawer = document.querySelector('#menu-drawer');
    if (!drawer) return;

    var container = drawer.closest('details');
    var summary = container && container.querySelector('summary.header__icon--menu');
    var header = document.querySelector('.header-wrapper');
    if (!container || !summary) return;

    function sync() {
      var open = container.hasAttribute('open') && container.classList.contains('menu-opening');
      drawer.classList.toggle('is-menu-open', open);
      summary.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (header) header.classList.toggle('icon-open', open);
    }

    /**
     * global.js leaves `.submenu-open` on a panel after a deeper level opens,
     * and CSS cannot tell a stale panel from the one holding a level open --
     * both carry `.submenu-open`, and the markup does not say which panel an
     * open `details` belongs to. So mark the panel that owns the deepest open
     * level with `data-open-level`; the stylesheet shows only that panel.
     */
    function markOpenLevel() {
      var openDetails = Array.prototype.slice.call(container.querySelectorAll('details[open]'));
      // the level the user is actually looking at: the open one that holds no
      // other open level inside it
      var deepest = openDetails.filter(function (details) {
        return (
          openDetails.filter(function (other) {
            return other !== details && details.contains(other);
          }).length === 0
        );
      })[0];

      var owner = deepest ? ownPanel(deepest) : null;
      drawer.querySelectorAll('.menu-drawer__submenu[data-open-level]').forEach(function (panel) {
        if (panel !== owner) panel.removeAttribute('data-open-level');
      });
      if (owner) owner.setAttribute('data-open-level', '');
    }

    /**
     * The panel a level draws in. Whatever the shape of the `details` -- a
     * top-level item wraps the whole row, a nested one wraps only its summary
     * -- the panel is a direct child, never an ancestor and never a sibling.
     * `closest()` would therefore always miss it.
     */
    function ownPanel(details) {
      var panel = details.firstElementChild;
      while (panel) {
        if (panel.matches('.menu-drawer__submenu')) return panel;
        panel = panel.nextElementSibling;
      }
      return null;
    }

    // `toggle` fires when the <details> opens, `click` runs after global.js has
    // moved the classes, and the mutation observer catches every later change
    // (submenu slide-over, Escape, close animation finishing). `subtree` is
    // required: the submenu <details> elements are descendants of the container,
    // not the container itself.
    container.addEventListener('toggle', sync);
    summary.addEventListener('click', function () {
      window.requestAnimationFrame(sync);
    });
    new MutationObserver(function () {
      sync();
      markOpenLevel();
    }).observe(container, {
      attributes: true,
      attributeFilter: ['open', 'class'],
      subtree: true,
    });

    sync();
    markOpenLevel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuDrawerState);
  } else {
    initMenuDrawerState();
  }
})();
